import {useLocation} from "react-router-dom";


export function isGuid(input: any) {
    //performs a loose GUID validation
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(input);
}

export function run(fn: any, thenFn: any, errorFn?: any, finallyFn?: any) {
    return () => (function () {
        let isMounted = true;

        const handleThen = (result: any) => {
            if (isMounted && thenFn) thenFn(result)
        };

        const handleError = (error: any) => {
            if (isMounted && errorFn) errorFn(error);
        }

        const handleFinally = (val: any) => {
            if (isMounted && finallyFn) finallyFn(val);
        }

        if (typeof fn === 'function')
            fn().then(handleThen).catch(handleError).finally(handleFinally)
        else
            fn.then(handleThen).catch(handleError).finally(handleFinally);

        return () => {
            isMounted = false;
        }
    })();
}

export const rand = (factor = 100000) => {
    return Math.round(Math.random() * 100000);
};

export function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export const preventDefault = (event: any) => event.preventDefault();

export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;


export function downloadFile(data: any, filename: any, mimetype?: any) {
    const blob = data.constructor !== Blob
        ? new Blob([data], {type: mimetype || 'application/octet-stream'})
        : data;

    if ((navigator as any).msSaveBlob) {
        (navigator as any).msSaveBlob(blob, filename);
        return;
    }

    let link = document.createElement('a'),
        url = window.URL,
        objectURL;

    if (mimetype) {
        link.type = mimetype;
    }

    link.download = filename || 'new file';
    link.href = objectURL = url.createObjectURL(blob);
    link.dispatchEvent(new MouseEvent('click'));
    setTimeout(url.revokeObjectURL.bind(url, objectURL));
}

export function toLocaleJsonDate (date: Date) {
    const targetDate = new Date(date);
    function addZ(n: number) {
        return (n<10? '0' : '') + n;
    }
    return targetDate.getFullYear() + '-' +
        addZ(targetDate.getMonth() + 1) + '-' +
        addZ(targetDate.getDate());
}

export function convertDateStringToLocaleJsonDate(expirationDate: string): string {
    const expiryDate = new Date(expirationDate);
    return toLocaleJsonDate(expiryDate);
}
